import script from "./WorkflowNode.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowNode.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowNode.vue?vue&type=style&index=0&id=019b148e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019b148e"]])

export default __exports__